import { useState } from 'react';
import styles from './Testimonial.module.scss';
import {
  CarouselApi,
  CarouselV2,
  Slide,
  Arrows,
} from '@/src/shared/components/Carousel/CarouselV2';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';
import { Section } from '../Section';
import { AgentCard } from './AgentCard';
import Testimonials from './data';

interface Props {
  showTitle?: boolean;
  title?: string;
  subtitle?: string;
}

export const Testimonial = ({ title, subtitle, showTitle = false }: Props) => {
  const [carouselApi, setCarouselApi] = useState<CarouselApi>(null);
  const isMobile = useIsMobile();

  return (
    <Section className={styles.sliderContainer}>
      {showTitle && <h3>{title}</h3>}
      {subtitle && <h4>{subtitle}</h4>}
      <CarouselV2
        classes={{ container: styles.carouselContainer }}
        getCarouselApi={setCarouselApi}
        dragFree={!isMobile}
        align="center"
      >
        {Testimonials.map((item) => (
          <Slide className={styles.card} key={item.title}>
            <AgentCard
              avatarUrl={item.avatarUrl}
              name={item.personName}
              title={item.title}
              role={item.role}
              comment={item.testimonialContent}
            />
          </Slide>
        ))}
      </CarouselV2>
      <Arrows
        carouselApi={carouselApi}
        classes={{ prev: styles.prevButton, next: styles.nextButton }}
      />
    </Section>
  );
};
